import { useQuery } from '@tanstack/react-query';
import { get } from '../api-client';
import type { FlagResponse } from '@/types/scheduling-api';

export function usePatientFlags(patientId: string | null) {
  return useQuery({
    queryKey: ['patient-flags', patientId],
    queryFn: ({ signal }) =>
      get<FlagResponse[]>(`/api/Appointment/PatientFlag?patientId=${patientId}`, { signal }),
    enabled: !!patientId,
  });
}
